module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-header"
  }, [_c('div', {
    staticClass: "paraller"
  }, [_c('div', {
    staticClass: "container   clearfix"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "top-side"
  }, [_c('ul', [_c('li', {
    staticClass: "top-side-item"
  }, [(_vm.user_info.email) ? _c('a', {
    attrs: {
      "href": "/profile.html#/user"
    }
  }, [_vm._v(_vm._s(_vm.user_info.email))]) : _c('a', {
    attrs: {
      "href": "/profile.html#/login"
    }
  }, [_vm._v("登录")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../assets/img/logo-white.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-142c7db0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/happypack/loader.js?id=ESLint!./app/components/TopHeader.vue
// module id = 42
// module chunks = 0 1 2 3 4